import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/vendas/vendedores/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findVendedores({
  empresa_cnpj,
  id = null,
  where = {},
  orwhere = {},
  include = "",
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere[${key}]=${orwhere[key]}`;
  });
  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include && `&include=${include}`
    }`,
    "GET",
    headers
  );
}

export async function findVendedorByCpfCnpj(empresa_cnpj, cpfcnpj) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}&where[cpfcnpj]=${cpfcnpj}`,
    "GET",
    headers
  );
}
